import { nullable, number, struct } from 'io-ts/Decoder';

import { Id as TransactionId } from '../../../../transaction/Id';
import { Id as ImageId } from '../../../../whole-house/image/Id';
import { ScalePath } from '../../../../whole-house/scale';
import { Id as TakeOffId } from '../../../../whole-house/take-off/Id';

export const Request = struct({
	transactionId: TransactionId,
	imageId: ImageId,
	takeOffId: TakeOffId,

	scale: nullable(number),
	scalePath: nullable(ScalePath),
});
